import React from 'react';
import { useIndexedDB } from 'react-indexed-db';

export default function WithHooksHOC(Component) {
  return props => {
    return <Component useIndexedDB={useIndexedDB} {...props} />;
  };
}
